<!-- 订单来源 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="orderSource" type="orderSource" clearable multiple/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-订单来源',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '订单来源：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const orderSource = useQuery('orderSource', props.value);

    return {
      orderSource,
    };
  },
};
</script>
